import React, {Component} from 'react';
import { Row, Col, FormControl } from 'react-bootstrap';
import { Checkbox, Radio } from 'react-icheck';
import PrintPreview from './PrintPreview';
import ReportStore from '../../stores/ReportStore';

const DEFAULT_ITEM_PER_PAGE = 20
class PrintReportKKCBillingNoteReceivable extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false,itemPerPage:DEFAULT_ITEM_PER_PAGE,dataList:[],data:[],report_title:'กำลังดึงข้อมูล..'}

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('landscape');
  }

  componentDidMount(){
    this.loadData(this.state.itemPerPage)
  }

  loadData(itemPerPage){
    ReportStore.loadReportBillingnoteReceivable(this.props.year,this.props.month,(result)=>{
      this.setState({data:result.data,dataList:this.getPagination(result.data,itemPerPage),report_title:'ไม่พบข้อมูล'})
    })
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  renderRowData(items,indexs) {
    if (items.length===0) {
      return(<tr><td colSpan={12}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        items.map((item,index)=>{
          return(
            <tr key={index}>
              <td className='text-center'>{item.bill_date}</td>
              <td className='text-center'>{item.claim_no}</td>
              <td>{item.customer_name}</td>
              <td className='text-center'>{item.car_registration_no}</td>
              <td className='text-center'>{item.bill_no}</td>
              <td className='text-right'>{this.getNumberFormat(item.amount)}</td>                  
              <td className='text-center'>{item.work_no}</td>
              <td className='text-right'>-</td>
              <td className='text-right'>-</td>
              <td className='text-center'></td>
              <td className='text-center'></td>
              <td className='text-center'></td>
            </tr>
          )
        })
      )
    }
  }

  renderTable(items,indexs) {
    return (
      <div className=''>
        <table className='table table-responsive table-hover table-bordered-solid table-report-kkc-billing-note-receivable table-print-report-kkc-billing-note-receivable'>
          <thead>
            <tr>
              <th rowSpan={2} className='text-center bg-none' style={{width:'120px'}}>ว/ด/ป วางบิล</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'150px'}}>เลขที่เคลม</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'200px'}}>บริษัท</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'220px'}}>ทะเบียนรถ</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'150px'}}>เลขที่ใบแจ้งหนี้<br/>ใบกำกับภาษี</th>
              <th rowSpan={2} className='text-center bg-none'>จำนวนเงิน</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'150px'}}>ลำดับเอกสาร</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'100px'}}>จำนวนเงิน<br/>ที่จะได้รับ</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'100px'}}>ค้างรับ</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'120px'}}>ว/ด/ป</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'150px'}}>เลขที่<br/>หัก ณ ที่จ่าย</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'150px'}}>ใบกำกับ<br/>ภาษีเลขที่</th>
            </tr>
          </thead>
          <tbody>
          {this.renderRowData(items,indexs)}
          </tbody>  
        </table>
      </div>
    )
  }

  renderComponentPage(items,indexs) {
    let {year,month} = this.props
    return(
      <div className='font-print' key={indexs}>
        <header style={{textAlign:'center',marginBottom:'20px'}}>
          <h2>{this.props.title} {month==='0'||month==='00'?'ปี ':'เดือน '+(month==='1'||month==='01'?'มกราคม':month==='2'||month==='02'?'กุมภาพันธ์':month==='3'||month==='03'?'มีนาคม':month==='4'||month==='04'?'เมษายน':month==='5'||month==='05'?'พฤษภาคม':month==='6'||month==='06'?'มิถุนายน':month==='7'||month==='07'?'กรกฎาคม':month==='8'||month==='08'?'สิงหาคม':month==='9'||month==='09'?'กันยายน':month==='10'?'ตุลาคม':month==='11'?'พฤศจิกายน':'ธันวาคม')} {year}</h2>
        </header>
        <div className='font-14'>   
          {this.renderTable(items,indexs)}          
        </div>
      </div>  
    )
  }

  getPagination(data,itemPerPage) {
    let checkRow = 0
    let newData = []
    let allData = []
    data.forEach(function(item,index) {
      if (checkRow<itemPerPage) {
        newData.push(item)
      }
      if (checkRow===itemPerPage-1||index===data.length-1) {
        allData.push(newData)
        newData = []
        checkRow = -1
      }
      checkRow++
    })

    return allData
  }

  onRowsPerPageChange(itemPerPage) {
    this.setState({itemPerPage:itemPerPage})
    this.loadData(itemPerPage)
  }

  renderNoData() {
    return(
      <div className='font-print'>
        <header className="text-center">
          <h2>{this.state.report_title}</h2>
        </header>
      </div>
    )
  }

  render() {
    let {loading,dataList} = this.state
    if (dataList.length===0) {
      return(
        <PrintPreview 
          loading={loading} 
          size={'landscape'}
          leftBarTitle={this.props.title}
        >
          {this.renderNoData()}
        </PrintPreview>
      )  
    } else {
      return(
        <PrintPreview 
          loading={loading} 
          size={'landscape'}
          leftBarTitle={this.props.title}
          defaultRowPerPage={20}
          startRowPerPage={10}
          endRowPerPage={25}
          onRowsPerPageChange={this.onRowsPerPageChange.bind(this)}
        >
          {
            dataList.map((item,index) => {
              return(
                this.renderComponentPage(item,index)
              )
            })
          }
        </PrintPreview>
      )
    }  
  }

}  

PrintReportKKCBillingNoteReceivable.defaultProps = {
  title: 'รายงานสรุปยอดใบวางบิลค้างรับ',  
  mode : '1'
}
export default PrintReportKKCBillingNoteReceivable;


// WEBPACK FOOTER //
// ./src/view/print/PrintReportKKCBillingNoteReceivable.js